
$(document).ready(function(){
  //   $('.HeroSlider').slick({
  //     dots: false,
  //     infinite: true,
  //     arrows: false,
  //     speed: 400,
  //     slidesToShow: 1,
  //     adaptiveHeight: true,
  //     autoplay: true,
  //     autoplaySpeed: 5000,
  //   });

  $('.HeroSlider').owlCarousel({
    items: 1,
    loop: true,
    nav: false,
    dots: false,
    autoplay: true,
    autoplayTimeout: 5000,
    animateIn: 'fadeIn'
  });


  // Quote carousel
  $('.quote-carousel').owlCarousel({
    items: 1,
    loop: true,
    nav: false,
    dots: true,
    autoplay: true,
    autoplayTimeout: 10000,
    navText: [
      '<i class="glyphicon glyphicon-menu-left"></i>',
      '<i class="glyphicon glyphicon-menu-right"></i>'
    ],
    responsive: {
      0: {
        items: 1
      },
      768: {
        items: 1
      }
    }
  });

});





$(window).scroll(function() {    
  var scroll = $(window).scrollTop();

  if (scroll >= 50) {
    $("#shopify-section-header").addClass("sticky");
  } else {
    $("#shopify-section-header").removeClass("sticky");
  }
});


$(document).ready(function(){
  // Select all links with hashes
  $('a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function(event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
      && 
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 500, function() {
          // Callback after animation
          // Must change focus!
          var $target = $(target);
          $target.focus();
          if ($target.is(":focus")) { // Checking if the target was focused
            return false;
          } else {
            $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
            $target.focus(); // Set focus again
          };
        });
      }
    }
  });
});

$(document).ready(function(){
  $('#play-film').click(function(){
    $('.video-placeholder-container').css("display", "none");
    $('#home-film').css("visibility", "visible");
    $('#home-film').trigger('play');
  });

  $('.menu_open').click(function(){
    $('body').addClass('menu_drawer_ac');
    $('#menu-drawer2').css('transform', 'translateX(0)');
  });
  $('.colse_menu').click(function(){
    $('body').removeClass('menu_drawer_ac');
    $('#menu-drawer2').css('transform', 'translateX(-100%)');
  });

  $(".menu_open").click(function() {
    $("html, body").animate({ scrollTop: 0 }, "slow");
    return false;
  });

  $("#mc-embedded-subscribe").on('click',function(){
    $('.hover_bkgr_fricc').removeClass('open');    
  });

});



